import * as React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import { Button, Grid } from "@material-ui/core"
import useLoginPopup from "../../../hooks/useLoginPopup"
import { useTrack } from "@hackler/react-sdk"
import usePlatform from "../../../hooks/usePlatform"
import { GAEvent } from "../../../modules/GoogleAnalytics"
import { FormattedMessage } from "react-intl"
import featureFlagMainVisualImg from "../../../assets/images/featureFlag/feature_flag_main_visual.png"
import featureFlagMainVisualImgMobile from "../../../assets/images/featureFlag/feature_flag_main_visual_mobile.png"
import featureFlagMainVisualImgEn from "../../../assets/images/featureFlag/feature_flag_main_visual_en.png"
import featureFlagMainVisualImgMobileEn from "../../../assets/images/featureFlag/feature_flag_main_visual_mobile_en.png"
import { Locale } from "../../../locale"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#051A52",
      backgroundSize: "auto 80%",
      padding: "48px 0 0",
      [theme.breakpoints.up("md")]: {
        padding: "80px 0 0",
        height: 934,
      },
    },
    title: {
      fontSize: "24px",
      lineHeight: "140%",
      color: "#FFFFFF",
      letterSpacing: -1,
      [theme.breakpoints.up("md")]: {
        fontSize: "48px",
      },
    },
    buttonWrapper: {
      marginBottom: 52,
      [theme.breakpoints.up("md")]: {
        marginBottom: 32,
      },
    },
    button: {
      borderRadius: 8,
      textTransform: "none",
      color: theme.palette.common.white,
      padding: "8px 16px",
      fontSize: 14,
      [theme.breakpoints.up("md")]: {
        padding: "12px 20px",
        fontSize: 20,
      },
    },
    imageWrapper: {
      "& img": {
        width: "100%",
        borderRadius: 4,
        filter: "drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.15))",
      },
      [theme.breakpoints.up("md")]: {
        marginBottom: -137,
        "& img": {
          width: "auto",
          maxWidth: 1156,
          borderRadius: 16,
          filter: "drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.15))",
        },
      },
    },
  })
)

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL
export default function FeatureFlagMainVisual() {
  const loginPopup = useLoginPopup()
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()
  const track = useTrack()
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Grid container style={{ textAlign: "center" }}>
        <Grid item xs={12} style={{ marginBottom: "34px" }}>
          {lang === "ko" ? (
            <strong className={classes.title}>
              <FormattedMessage id={"service_description_feature_flag1"} />
              <br />
              <FormattedMessage id={"service_description_feature_flag2"} />
            </strong>
          ) : (
            <strong className={classes.title}>
              Reduce deployment risk {isMobile && <br />}and rollout features
              <br />
              whenever you want
            </strong>
          )}
        </Grid>
        <Grid className={classes.buttonWrapper} item xs={12}>
          <Button
            onClick={() => {
              track({ key: "homepage_all_feature_flag_start_click" })
              track({ key: "homepage_feature_flag_section_1_feature_flag_start_click" })
              GAEvent({
                category: "feature flag-1",
                action: "click",
                label: "start feature flag",
              })
              loginPopup(`${dashboardUrl}/feature-flags`)
            }}
            color={"primary"}
            variant={"contained"}
            className={classes.button}>
            <strong>
              <FormattedMessage id={"btn_feature_flag_hero_section"} />
            </strong>
          </Button>
        </Grid>
        <Grid item xs={12} className={classes.imageWrapper}>
          {lang === "ko" ? (
            <img src={isMobile ? featureFlagMainVisualImgMobile : featureFlagMainVisualImg} />
          ) : (
            <img src={isMobile ? featureFlagMainVisualImgMobileEn : featureFlagMainVisualImgEn} />
          )}
        </Grid>
      </Grid>
    </div>
  )
}
